var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_vm._m(0),_c('div',{staticClass:"grid grid-cols-3 gap-8 my-8"},_vm._l((_vm.paymentGateway),function(gateway){return _c('div',{key:gateway._id,staticClass:"w-full"},[_c('Gateway',{attrs:{"gateway":gateway}})],1)}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full p-5 bg-white"},[_c('h2',{staticClass:"text-xl mb-0 font-semibold"},[_vm._v("Connected Payment Gateway")])])
}]

export { render, staticRenderFns }